<mat-card>
  <h2>{{ status }}</h2>
  <!-- CONTENT -->
  <mat-card-content>
    <div class="table__wrapper">
      <!-- TABLE -->
      <table aria-label="operation-validation" mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="agent">
          <th mat-header-cell *matHeaderCellDef class="first-row" translate>operationValidation.agent</th>
          <td mat-cell class="first-row" *matCellDef="let element">{{ element.businessName }}</td>
        </ng-container>
        <ng-container matColumnDef="numContract">
          <th mat-header-cell *matHeaderCellDef translate>operationValidation.numContract</th>
          <td mat-cell *matCellDef="let element">{{ element.numRequest }}</td>
        </ng-container>
        <ng-container matColumnDef="documentHolder">
          <th mat-header-cell *matHeaderCellDef translate>operationValidation.documentHolder</th>
          <td mat-cell *matCellDef="let element">{{ element.holderDoc }}</td>
        </ng-container>
        <ng-container matColumnDef="document">
          <th mat-header-cell *matHeaderCellDef translate>operationValidation.document</th>
          <td mat-cell *matCellDef="let element">{{ element.documentDesc }}</td>
        </ng-container>
        <ng-container matColumnDef="documentSituation">
          <th mat-header-cell *matHeaderCellDef translate>operationValidation.documentSituation</th>
          <td mat-cell *matCellDef="let element">{{ element.documentStatus }}</td>
        </ng-container>
        <ng-container matColumnDef="incidenceDate">
          <th mat-header-cell *matHeaderCellDef translate>operationValidation.incidenceDate</th>
          <td mat-cell *matCellDef="let element">{{ element.creationDate }}</td>
        </ng-container>
        <ng-container matColumnDef="formalizedDate">
          <th mat-header-cell *matHeaderCellDef translate>operationValidation.formalizedDate</th>
          <td mat-cell *matCellDef="let element">{{ element.formalizationDate }}</td>
        </ng-container>
        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef translate>operationValidation.expirationDate</th>
          <td mat-cell *matCellDef="let element">{{ element.expirationDate }}</td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </mat-card-content>
</mat-card>
